// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__14ftZ","detailsBorder":"styles_detailsBorder__JeMzK"};